var messages = {
  moveAll: 'すべて移動',
  item: 'アイテム',
  items: 'アイテム'
};
export default messages;